﻿export const processIframe = (el) => {
  el.contentWindow.location.replace(el.dataset.src);
  el.removeAttribute("data-src");
};
